import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Formik, Form, Field } from "formik"
import { connect } from "react-redux"
import compose from "ramda/src/compose"
import PropTypes from "prop-types"
import _map from "lodash/map"
import _filter from "lodash/filter"
import _get from "lodash/get"
import _clone from "lodash/clone"
import _set from "lodash/set"
import _isEmpty from "lodash/isEmpty"
import _last from "lodash/last"
import _split from "lodash/split"

import {
  TELEFONIA_FIXA,
  TELEFONIA_MOVEL
} from "services/state/billing/constants"
import { maskTelCustom } from "services/utils/mask"

import SelectSearchable from "shared/components/SelectSearchable"

import styles from "./styles.css"

const ProductForm = ({ validProducts, onChange }) => {
  const [values, setValues] = useState({
    lineOfBusiness: "",
    assetId: ""
  })

  const productByProductLine = useCallback(
    (line) => {
      return _filter(validProducts, (product) => {
        const productLine = _get(
          product,
          "productLine.name",
          _get(product, "lineOfBusiness", "")
        )
        return productLine.toUpperCase() === line.toUpperCase()
      })
    },
    [validProducts]
  )

  const lineOfBusiness = [
    {
      label: "Celular",
      value: TELEFONIA_MOVEL,
      products: productByProductLine(TELEFONIA_MOVEL)
    },
    {
      label: "Telefone fixo",
      value: TELEFONIA_FIXA,
      products: productByProductLine(TELEFONIA_FIXA)
    }
  ]

  const lineOfBusinessOptions = _filter(
    lineOfBusiness,
    (line) => !_isEmpty(line.products)
  )

  const productsOptions = useMemo(() => {
    if (!values.lineOfBusiness) return []

    const productsFiltered = productByProductLine(values.lineOfBusiness)

    return _map(productsFiltered, (product) => {
      const description = _get(product, "description", "")
      return {
        label: `${maskTelCustom(product.assetTag)} - ${_last(
          _split(description, "-")
        )}`,
        value: product.assetId
      }
    })
  }, [values.lineOfBusiness])

  const handleChange = useCallback((key, e) => {
    setValues((currentValues) => {
      const newValues = _clone(currentValues)
      _set(newValues, key, e.value)

      if (onChange) onChange(newValues)

      return newValues
    })
  }, [])

  const hasOneLineOfBusinessoption = lineOfBusinessOptions.length === 1
  const hasOneProduct = productsOptions.length === 1

  useEffect(() => {
    if (hasOneLineOfBusinessoption) {
      handleChange("lineOfBusiness", {
        value: _get(lineOfBusinessOptions, [0, "value"], "")
      })
    }
  }, [])

  useEffect(() => {
    if (hasOneProduct) {
      handleChange("assetId", {
        value: _get(productsOptions, [0, "value"], "")
      })
    }
  }, [values.lineOfBusiness, productsOptions])

  return (
    <Formik
      enableReinitialize
      initialValues={{ lineOfBusiness: "", productAssetTag: "" }}
      render={() => (
        <Form className={styles.form}>
          <Field
            id="lineOfBusiness"
            name="lineOfBusiness"
            component={SelectSearchable}
            options={lineOfBusinessOptions}
            value={values.lineOfBusiness}
            label="Selecione o tipo de produto"
            placeholder={false}
            onChange={(e) => handleChange("lineOfBusiness", e)}
            styles={SelectFieldStyles}
          />
          <Field
            id="assetId"
            name="assetId"
            component={SelectSearchable}
            options={productsOptions}
            value={values.assetId}
            label="Selecione a linha"
            placeholder={false}
            onChange={(e) => handleChange("assetId", e)}
            styles={SelectFieldStyles}
            isDisabled={!values.lineOfBusiness}
          />
        </Form>
      )}
    />
  )
}

const SelectFieldStyles = {
  menuList: {
    maxHeight: "200px"
  }
}
ProductForm.propTypes = {
  validProducts: PropTypes.object,
  onChange: PropTypes.func
}

ProductForm.defaultProps = {
  validProducts: [],
  onChange: () => {}
}

const mapStateToProps = () => ({})

const enhance = compose(connect(mapStateToProps, {}))

export default enhance(ProductForm)



// WEBPACK FOOTER //
// ./src/scenes/ConsumptionProfile/components/ProductForm/index.js